import { NotFound, RouteErrorBoundary } from '@zuruflex/ui';
import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './components/AppLayout.js';
import { RequireAuth } from './components/RequireAuth.js';
import { BookingsPage } from './pages/BookingsPage.js';
import { CarDetailPage } from './pages/CarDetailPage.js';
import { FleetPage } from './pages/FleetPage.js';
import { InboxPage } from './pages/InboxPage.js';
import { OverviewPage } from './pages/OverviewPage.js';
import { PromotionDetailPage } from './pages/PromotionDetailPage.js';
import { PromotionsPage } from './pages/PromotionsPage.js';
import { ReviewsPage } from './pages/ReviewsPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { TermsPage } from './pages/TermsPage.js';
import { VerificationPage } from './pages/VerificationPage.js';

export const router = createBrowserRouter([
  {
    // Everything sits behind the gate. Sign-in and sign-up are rendered by
    // the gate itself, so they have no routes of their own to guard.
    element: <RequireAuth />,
    // Catches a throw from anywhere below, the gate itself included, so a
    // broken component shows this rather than React Router's stack trace.
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'fleet', element: <FleetPage /> },
          { path: 'fleet/:id', element: <CarDetailPage /> },
          { path: 'bookings', element: <BookingsPage /> },
          { path: 'promotions', element: <PromotionsPage /> },
          { path: 'promotions/:id', element: <PromotionDetailPage /> },
          { path: 'inbox', element: <InboxPage /> },
          { path: 'inbox/:id', element: <InboxPage /> },
          { path: 'reviews', element: <ReviewsPage /> },
          { path: 'verification', element: <VerificationPage /> },
          { path: 'terms', element: <TermsPage /> },
          { path: 'settings', element: <SettingsPage /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
]);
